export const PAGINATION_LIMIT = 20000;
export const MAX_RESULT_WINDOW = 2000000;
